/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminCategory,
    AdminCategoryFromJSON,
    AdminCategoryFromJSONTyped,
    AdminCategoryToJSON,
} from './AdminCategory';

/**
 * 
 * @export
 * @interface AdminCategoryListResp
 */
export interface AdminCategoryListResp {
    /**
     * 
     * @type {Array<AdminCategory>}
     * @memberof AdminCategoryListResp
     */
    items?: Array<AdminCategory>;
}

export function AdminCategoryListRespFromJSON(json: any): AdminCategoryListResp {
    return AdminCategoryListRespFromJSONTyped(json, false);
}

export function AdminCategoryListRespFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminCategoryListResp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : ((json['items'] as Array<any>).map(AdminCategoryFromJSON)),
    };
}

export function AdminCategoryListRespToJSON(value?: AdminCategoryListResp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': !value.items ? undefined : ((value.items as Array<any>).map(AdminCategoryToJSON)),
    };
}

